import { render, staticRenderFns } from "./MenuVertical.vue?vue&type=template&id=f44d12de&scoped=true&"
import script from "./MenuVertical.vue?vue&type=script&lang=js&"
export * from "./MenuVertical.vue?vue&type=script&lang=js&"
import style0 from "./MenuVertical.vue?vue&type=style&index=0&id=f44d12de&scoped=true&lang=css&"
import style1 from "./MenuVertical.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44d12de",
  null
  
)

export default component.exports